<ul class="selection-menu">
    <li (click)="state.update(() => 'all')" [class]="state() === 'all' ? 'active' : 'inactive'">{{ 'notifications.filter.all' | translate }}</li>
    <li (click)="state.update(() => 'unread')" [class]="state() === 'unread' ? 'active' : 'inactive'">{{ 'notifications.filter.unread' | translate }}</li>
    <li>
        <a>{{ 'notifications.see_all' | translate }}</a>
    </li>
</ul>

<ul class="notification-list">
    @if (notifications().length > 0) {
    @for (notif of notifications(); track $index) {
    <li class="item" [class.unread]="!notif.isRead">
        <span class="date">{{ notif.date | date: 'dd/MM/yy, HH:mm' }}</span>
        <kin-icon [class.unread]="!notif.isRead" [name]="notif.icon" />
        @if (notif.type === 'KINO_MESSAGE') {
        <p class="title">{{ notif.title }}</p>
        } @else {
        <p class="title">{{ notif.contentTitle }}</p>
        }
        <p class="tip">{{ notif.tip }}</p>
    </li>
    }
    } @else {
    <p class="empty">{{ 'notifications.empty' | translate }}</p>
    }
</ul>